var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
var isDigit = function (c) { return c >= "0" && c <= "9"; };
var DIGITS = ["9", "8", "7", "6", "5", "4", "3", "2", "1", "0"];
var DigitSlot = function (_a) {
    var digit = _a.digit, animKey = _a.animKey, delay = _a.delay;
    var targetY = "".concat(-(9 - parseInt(digit)), "em");
    var _b = useState(targetY), y = _b[0], setY = _b[1];
    var _c = useState("none"), transition = _c[0], setTransition = _c[1];
    var isFirst = useRef(true);
    useEffect(function () {
        if (isFirst.current) {
            isFirst.current = false;
            return;
        }
        setTransition("none");
        setY("0em");
        var raf;
        var timer;
        raf = requestAnimationFrame(function () {
            timer = setTimeout(function () {
                setTransition("transform 0.7s cubic-bezier(0.15, 0.85, 0.3, 1)");
                setY(targetY);
            }, delay);
        });
        return function () {
            cancelAnimationFrame(raf);
            clearTimeout(timer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [animKey]);
    return (_jsx("span", { style: { display: "inline-block", overflow: "hidden", height: "1em", verticalAlign: "bottom" }, children: _jsx("span", { style: { display: "block", transform: "translateY(".concat(y, ")"), transition: transition, willChange: "transform" }, children: DIGITS.map(function (d) { return (_jsx("span", { style: { display: "block", height: "1em", lineHeight: "1", textAlign: "center" }, children: d }, d)); }) }) }));
};
var RollingValue = function (_a) {
    var value = _a.value, style = _a.style;
    var _b = useState(value), cur = _b[0], setCur = _b[1];
    var _c = useState(value), prev = _c[0], setPrev = _c[1];
    var _d = useState(0), animKey = _d[0], setAnimKey = _d[1];
    var curRef = useRef(value);
    useEffect(function () {
        if (value === curRef.current)
            return;
        setPrev(curRef.current);
        setCur(value);
        curRef.current = value;
        setAnimKey(function (k) { return k + 1; });
    }, [value]);
    var maxLen = Math.max(cur.length, prev.length);
    var paddedCur = cur.padStart(maxLen, " ");
    var paddedPrev = prev.padStart(maxLen, " ");
    var digitRanks = {};
    var rank = 0;
    for (var i = maxLen - 1; i >= 0; i--) {
        if (isDigit(paddedCur[i])) {
            digitRanks[i] = rank++;
        }
    }
    return (_jsx("span", { style: __assign({ display: "inline-flex", alignItems: "center", lineHeight: 1 }, style), children: paddedCur.split("").map(function (char, i) {
            var _a;
            if (char === " ")
                return null;
            if (!isDigit(char)) {
                return _jsx("span", { style: { display: "inline-block" }, children: char }, i);
            }
            var digitChanged = paddedCur[i] !== paddedPrev[i] && animKey > 0;
            var delay = digitChanged ? ((_a = digitRanks[i]) !== null && _a !== void 0 ? _a : 0) * 60 : 0;
            return (_jsx(DigitSlot, { digit: char, animKey: digitChanged ? animKey : 0, delay: delay }, i));
        }) }));
};
export default RollingValue;
